var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"banner"}),_c('router-view',{staticStyle:{"min-height":"calc(100vh - 7.5rem)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }